(function () {
  function closeAllModals(modals) {
    modals.forEach(function (modal) {
      modal.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.classList.remove('no-scroll');
  }

  function initPurchaseAssuranceModal(modal, allModals) {
    if (!modal || modal.dataset.initialized === 'true') return;

    var openButtons = document.querySelectorAll('[data-action="open-purchase-assurance-modal"][aria-controls="' + modal.id + '"]');

    function openModal() {
      closeAllModals(allModals);
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openModal();
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-action="close-purchase-assurance-modal"]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    modal.dataset.initialized = 'true';
  }

  var modals = Array.prototype.slice.call(document.querySelectorAll('[data-purchase-assurance-modal]'));
  modals.forEach(function (modal) {
    initPurchaseAssuranceModal(modal, modals);
  });
})();
